/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function SelectDraftClipModalController (this: JS5Object) {
    this.selectClip = (clip: JS5Object) => {
        this.selectedClip = (this.selectedClip !== clip) ? clip : null;
    };

    this.searchDrafts = (clip: JS5Object) => {
        return !this.draftClipSearch.length ||
            (clip.title &&
             clip.title.toLowerCase().indexOf(this.draftClipSearch.toLowerCase()) !== -1);
    };

    this.onOk = (clip: JS5Object) => {
        this.close({$value: clip});
    };

    this.cancel = () => {
        this.dismiss({$value: 'cancel'});
    };

    this.$onInit = () => {
        this.draftClipSearch = '';
    };
}

angular.module('prism-ui.package').component('selectDraftClipModal', {
    templateUrl: 'package/editor/components/view/liveclip/modals/selectDraftClip/select-draft-clip-modal-template.html',
    controller: SelectDraftClipModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});
